import { AdsUtils } from './Utils';
import asyncPinObserver from '../Pin/AsyncPinObserver';
import { AAFPLAYER_PLAY } from 'src/AAFPlayer/constants';
import store from 'src/store';
import logger from 'src/utils/logger/logger';


const ExperienceHourRefresh = (function() {
    let isExperienceTimeout = null;
    let timeoutTime = null;
    let lastNavType = null;
    let isPlaying = false;
    let historyglobal;
    let nodes = null;

    const flowRedirectNodeHomeUser = function() {
      if (isPlaying) {
        isPlaying = false;
        const code = nodes && nodes[0] && nodes[0].code ? nodes[0].code : 'homeuser';
        if (historyglobal) {
            historyglobal.push(`/node/${code}`);
        }
      }
    }

    const whenPlayerStop = function(who) {
        if (who === 'player_stop') {
          flowRedirectNodeHomeUser()
        }
    };

    asyncPinObserver.subscribe(whenPlayerStop);

    const whenPlayerStopBitmovin = function() {
      flowRedirectNodeHomeUser()
    };

    const getIsExperienceTimeout = function() {
        return isExperienceTimeout;
    };

    const getLastNavType = function() {
        return lastNavType;
    };

    const getIsPlaying = function() {
        return isPlaying;
    };

    const setTimeoutExperience = function(nav, redirectToHome) {
        const experienceHourRefresh = AdsUtils.getexperience_hour_refresh();
        lastNavType = nav;
        historyglobal = AdsUtils.getProps();
        nodes = store.getState().navbar.nodes;

        if (typeof experienceHourRefresh !== 'number' || isNaN(experienceHourRefresh) || experienceHourRefresh <= 0 || experienceHourRefresh > 596) {
            logger.debug(":::/[UtilsExperience] - Experience timeout disabled", experienceHourRefresh);
            return;
        }
        if (!timeoutTime) {
            timeoutTime = experienceHourRefresh * 60 * 60 * 1000;
        }
        if (isExperienceTimeout) {
            clearTimeout(isExperienceTimeout);
            isExperienceTimeout = null;
        }
        logger.debug('redirectToHome', redirectToHome)


        const currentNavType = AdsUtils.getUserType();

        if (timeoutTime && timeoutTime !== 0) {
            isExperienceTimeout = setTimeout(() => {
                let redirectToHome = true;
                AdsUtils.loadUserType(redirectToHome);
            }, timeoutTime);
        }
        logger.debug('redirectToHome', redirectToHome)

        if ( lastNavType && currentNavType && lastNavType !== currentNavType && redirectToHome) { //


            lastNavType = currentNavType;
            let playerState = store.getState().player.playerstate;

            if (playerState === AAFPLAYER_PLAY) {
                isPlaying = true;
            } else {
                const code = nodes && nodes[0] && nodes[0].code ? nodes[0].code : 'homeuser';
                historyglobal.push(`/node/${code}`);
            }
        }
    };

    return {
        setTimeoutExperience,
        whenPlayerStop,
        getIsExperienceTimeout,
        getLastNavType,
        getIsPlaying,
        whenPlayerStopBitmovin
    };

})();

export default ExperienceHourRefresh;



// WEBPACK FOOTER //
// ./src/AAF/Ads/AdsTimer.js